import React from 'react';
import { Icon } from '../Icon';
import { CUSTOM_CATEGORY_ICONS, CustomIconOption } from '../../utils/customCategoryIcons';
import './IconPicker.css';

interface IconPickerProps {
  selectedIcon?: string;
  onIconSelect: (icon: CustomIconOption) => void;
}

export const IconPicker: React.FC<IconPickerProps> = ({ selectedIcon, onIconSelect }) => {
  return (
    <div className="icon-picker">
      <label className="icon-picker__label">Выберите иконку (свайп влево/вправо)</label>
      <div className="icon-picker__scroll">
        {CUSTOM_CATEGORY_ICONS.map((iconOption, index) => {
          const isSelected = Boolean(selectedIcon && selectedIcon === iconOption.icon);
          return (
            <button
              key={`${iconOption.icon}-${index}-${iconOption.name}`}
              className={`icon-picker__button ${isSelected ? 'icon-picker__button--selected' : ''}`}
              onClick={() => onIconSelect(iconOption)}
              type="button"
            >
              <div
                className="icon-picker__icon-container"
                style={{
                  backgroundColor: iconOption.backgroundColor,
                }}
              >
                <Icon
                  name={iconOption.icon}
                  size={25}
                  color={iconOption.color}
                />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

